import styled, { css } from 'styled-components';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import blockedPattern from '@bechtel/client-assets/dist/images/pattern-red.svg';
import { Box, TextStyled, Heading, Icon, Text } from '@bechtel/gds';

interface BlockStatus {
  isClosed: boolean;
}

export const BlockHeaderWidth = '220px';
export const BlockHeaderSmallWidth = '168px';

export const BlockCardWidth = '360px';
export const BlockCardHeight = '390px';

export const BlockCardSmallWidth = '290px';
export const BlockCardSmallHeight = '295px';

export const CommentsWidth = '275px';
export const CommentsSmallWidth = '205px';

export const ImagePreviewHeight = '175px';
export const ImagePreviewSmallHeight = '120px';

interface ItemContainerStyledProps {
  itemsInSingleRow: boolean;
}

export const ItemContainerStyled = styled.div<ItemContainerStyledProps>`
  display: grid;
  grid-template-columns: repeat(auto-fill, ${BlockCardWidth});
  grid-auto-rows: ${BlockCardHeight};
  grid-gap: ${({ theme }) => theme.spacings[500]} ${({ theme }) => theme.spacings[500]};
  justify-content: ${({ itemsInSingleRow }) => (itemsInSingleRow ? 'start' : 'center')};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    grid-template-columns: repeat(auto-fill, ${BlockCardSmallWidth});
    grid-auto-rows: ${BlockCardSmallHeight};
  }
`;

export const BlockCardlHeadingStyled = styled(Box).attrs({
  p: { sm: '400' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    font-weight: ${theme.fontWeights[600]};
    ${(props: BlockStatus) =>
      props.isClosed
        ? css`
            background-color: ${theme.colors.grey[200]};
          `
        : css`
            background-color: ${theme.colors.red[200]};
          `}
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      font-size: ${theme.fontSizes[300]};
      padding-top: ${theme.spacings[300]};
      padding-bottom: ${theme.spacings[300]};
    }
  `}
`;

export const BlockCardItemStyled = styled.div`
  ${({ theme }) => css`
    border-radius: ${theme.radii[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
    cursor: pointer;
    overflow: hidden;
    ${(props: BlockStatus) =>
      props.isClosed
        ? css`
            background-color: ${theme.colors.grey[100]};
          `
        : css`
            background-color: ${theme.colors.red[100]};
          `}
  `}
`;

export const BlockCardTopBorderStyled = styled(Box)`
  ${({ theme }) => css`
    height: ${theme.spacings[300]};
    background-repeat: repeat;
    ${(props: BlockStatus) =>
      props.isClosed
        ? css`
            background-color: ${theme.colors.grey[600]};
          `
        : css`
            background-color: ${theme.colors.red[400]};
            background-image: url(${blockedPattern});
            background-size: ${theme.fontSizes[250]};
          `}
  `}
`;

export const BlockCardBorderBox = styled.div`
  ${({ theme }) => css`
    height: 100%;
    border-top: none;
    ${(props: BlockStatus) =>
      props.isClosed
        ? css`
            border: 1px solid ${theme.colors.grey[300]};
          `
        : css`
            border: 1px solid ${theme.colors.red[300]};
          `}
  `}
`;

export const BlockCardLeftIconStyled = styled(Box).attrs({ justifyContent: { sm: 'flex-start' }, pl: { sm: '200' } })`
  cursor: pointer;
  position: absolute;
  height: 100%;
  width: ${({ theme }) => theme.spacings[700]};
  left: 0;
`;

export const ImageBoxStyled = styled(Box)`
  height: ${ImagePreviewHeight};

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    height: ${ImagePreviewSmallHeight};
  }
`;

export const BlockCardDetailStyled = styled(Box).attrs({ pl: { sm: '400' }, pt: { sm: '200' }, pb: { sm: '400' } })`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      font-size: ${theme.fontSizes[300]};
      padding-bottom: ${theme.spacings[200]};
    }
  `}
`;
export const BlockCardDetailCommentStyled = styled(BlockCardDetailStyled).attrs({
  pt: { sm: '400' },
})`
  line-height: normal;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      font-size: ${theme.fontSizes[300]};
    }
  `};
`;

export const BlockCardRightIconStyled = styled(Box).attrs({ justifyContent: { sm: 'flex-end' }, pr: { sm: '200' } })`
  cursor: pointer;
  position: absolute;
  height: 100%;
  width: ${({ theme }) => theme.spacings[700]};
  right: 0;
`;

export const InfoStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  pb: { sm: '400' },
})`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    padding-bottom: ${({ theme }) => theme.spacings[200]};
  }
`;

export const UserInfoStyled = styled(Box).attrs({
  flexBasis: { sm: '0' },
  flexGrow: { sm: '1' },
  flexShrink: { sm: '1' },
  pt: { sm: '200' },
})`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    padding-top: ${({ theme }) => theme.spacings[200]};
  }
`;

export const UserNameTextLabelStyled = styled(Text).attrs({
  color: 'grey.1000',
  size: '400',
  justifyContent: { sm: 'center' },
})`
  padding-top: ${({ theme }) => theme.spacings[400]};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    font-size: ${({ theme }) => theme.fontSizes[300]};
    padding-top: ${({ theme }) => theme.spacings[400]};
  }
`;

export const FooterTextLabelStyled = styled(Text).attrs({
  color: 'grey.1000',
  size: '400',
})`
  padding-bottom: ${({ theme }) => theme.spacings[400]};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    font-size: ${({ theme }) => theme.fontSizes[300]};
    padding-bottom: ${({ theme }) => theme.spacings[300]};
  }
`;
export const FooterTextValueStyled = styled(Text).attrs({
  color: 'grey.600',
  size: '400',
})`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    font-size: ${({ theme }) => theme.fontSizes[300]};
  }
`;

export const BlockCardInfoStyled = styled(Box).attrs({
  pr: { sm: '600' },
})`
  ${({ theme }) => css`
    position: relative;
    ${TextStyled} {
      position: absolute;
      top: 0px;
      left: ${theme.spacings[500]};
      padding: ${theme.spacings[100]};
      background-color: ${theme.colors.white};
      border-radius: ${theme.spacings[300]};
    }
    @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
      padding-right: ${theme.spacings[500]};
    }
  `}
`;

export const HeadingStyled = styled(Heading).attrs({
  color: 'grey.1000',
  size: '400',
  weight: '600',
})`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: ${BlockHeaderWidth};
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      font-size: ${theme.fontSizes[300]};
      max-width: ${BlockHeaderSmallWidth};
    }
  `}
`;

export const BlockStatusStyled = styled(Text).attrs({
  size: '400',
  weight: '600',
})`
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      font-size: ${theme.fontSizes[300]};
    }
  `}
`;
export const IconStyled = styled(Icon).attrs({
  iconStyle: 'duo',
  icon: 'image-polaroid',
})`
  ${({ theme }) => css`
    ${(props: BlockStatus) =>
      props.isClosed
        ? css`
            color: ${theme.colors.grey[300]};
          `
        : css`
            color: ${theme.colors.red[300]};
          `}
  `}
  width: 78px;
  & > svg {
    height: 50px;
  }
`;

export const BlockImageSeparatorStyled = styled(Box).attrs({ pt: { sm: '400' }, mx: { sm: '400' } })`
  ${({ theme }) => css`
    ${(props: BlockStatus) =>
      props.isClosed
        ? css`
            border-top: 1px solid ${theme.colors.grey[300]};
          `
        : css`
            border-top: 1px solid ${theme.colors.red[300]};
          `}
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      padding-top: ${theme.spacings[200]};
    }
  `}
`;

export const BlockForemanSeparatorStyled = styled(Box).attrs({
  flexGrow: { sm: '1' },
  flexShrink: { sm: '1' },
  flexBasis: { sm: '0' },
  pt: { sm: '200' },
  pl: { sm: '400' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    ${(props: BlockStatus) =>
      props.isClosed
        ? css`
            border-left: 1px solid ${theme.colors.grey[300]};
          `
        : css`
            border-left: 1px solid ${theme.colors.red[300]};
          `}
  `}
`;

export const ImageBox = styled(Box).attrs({
  flexGrow: { sm: 1 },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    ${(props: BlockStatus) =>
      props.isClosed
        ? css`
            border-top: 1px solid ${theme.colors.grey[300]};
            border-bottom: 1px solid ${theme.colors.grey[300]};
          `
        : css`
            border-top: 1px solid ${theme.colors.red[300]};
            border-bottom: 1px solid ${theme.colors.red[300]};
          `}
  `}
`;
export const CommentTextStyled = styled(Text).attrs({
  color: 'grey.600',
  size: '400',
})`
  width: ${CommentsWidth};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: ${CommentsSmallWidth};
    font-size: ${({ theme }) => theme.fontSizes[300]};
  }
`;

export const NoBlocksFoundStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  pt: { sm: '600' },
  pb: { sm: '700' },
  alignSelf: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  ${({ theme }) => css`
    border-radius: 0 0 ${theme.spacings[200]} ${theme.spacings[200]};
    background-color: ${theme.colors.white};
    border-top: 6px solid ${theme.colors.bechtel.blue['000']};
    width: 488px;
    text-align: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
      top: 55%;
    }
    @media only screen and (max-height: ${({ theme }) => theme.breakpoints.tablet}) {
      top: 60%;
    }
  `}
`;
